module.exports = __webpack_public_path__ + "img/yaoshi_gaoji-1.e276fd9f.png";